import { render } from "./PeriodicMovementBySeaReport.vue?vue&type=template&id=ad82f3d8"
import script from "./PeriodicMovementBySeaReport.vue?vue&type=script&lang=js"
export * from "./PeriodicMovementBySeaReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__